var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mangel-status-icon",class:_vm.className,attrs:{"title":_vm.status}},[(_vm.status != null && _vm.icon != null)?_c('fa-icon',{attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }